import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { AppQueryParams, Languages } from '../../constants';
import { useApplicationParams, useLanguage } from '../../context';

export const getBillingOptions = (productDetails) => {
  return (productDetails?.billingOptions || []).reduce(
    (options, option) => {
      if (option.method === 'points') {
        options.isRedeemable = true;
      }

      if (option.method === 'creditCard') {
        options.isPurchasable = true;
      }

      return options;
    },
    { isRedeemable: false, isPurchasable: false },
  );
};

export const useProductDetails = () => {
  const [productDetails, setProductDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const { appVersion, platform, deviceId, userToken } = useApplicationParams();
  const { language } = useLanguage();

  const routeParams = useParams();
  const [searchParams] = useSearchParams();

  const productId = searchParams.get(AppQueryParams.ProductId) || routeParams.productId;

  useEffect(() => {
    const cancelToken = axios.CancelToken.source();

    const getProductDetails = async () => {
      try {
        setIsLoading(true);

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/shopv2/get/product?productId=${productId}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'x-api-version': appVersion || '4.11.1',
              'x-api-key': process.env.REACT_APP_API_KEY,
              'x-api-os': platform || 'android',
              'x-user-lang': language || Languages.English,
              'x-api-device-id': deviceId || 'CBC64810-FF0C-4008-9558-A999C18085E7',
              authorization: userToken || '',
            },
            cancelToken: cancelToken.token,
          },
        );

        if (response.data?.status === 'success' && response.data.data) {
          setProductDetails(response.data.data);
        }
      } catch (error) {
        console.error(`Error get product details for ${productId}: ${error?.message}`);
      } finally {
        setIsLoading(false);
      }
    };

    getProductDetails();

    return () => {
      cancelToken.cancel();
    };
  }, [productId, language]);

  return {
    isLoading,
    productDetails,
    productId,
  };
};
